import { render, staticRenderFns } from "./ListGuardGroup.vue?vue&type=template&id=b2cc9356"
import script from "./ListGuardGroup.vue?vue&type=script&lang=js"
export * from "./ListGuardGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports